The granular status of the application or position.
